import {useQuery} from 'react-query';

import {getStoreInfo} from '../../../services/store';

const UseGetStoreInfo = (storeId: string) => {
  const {
    data: storeInfo,
    isLoading,
    isSuccess,
    refetch,
  } = useQuery(['getStoreInfo', storeId], () => getStoreInfo(storeId));
  return {storeInfo, isLoading, isSuccess, refetch};
};

export default UseGetStoreInfo;
